import { Tabs } from "@mantine/core";
import { useState } from "react";
import PanelUserTable from "./PanelUserTable";
import EmployeeTable from "./EmployeeTable";
import TabletTable from "./TabletTable";
import { useSearchParams } from "react-router";


const CompanyDetailTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "user";

  const handleTabChange = (value: string | null) => {
    setSearchParams({ tab: value || "user" });
  };

  return (
    <div style={{ width: "100%" }}>
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab value="user">HR Kullanıcıları</Tabs.Tab>
          <Tabs.Tab value="employee">Çalışanlar</Tabs.Tab>
          <Tabs.Tab value="tablet">Tabletler</Tabs.Tab>
        </Tabs.List>
      </Tabs>

      <div style={{ marginTop: 16 }}>
        {activeTab === "user" && <PanelUserTable />}{" "}
        {/* Kullanıcılar için tablo */}
        {activeTab === "employee" && <EmployeeTable />}{" "}
        {/* Çalışanlar için tablo */}
        {activeTab === "tablet" && <TabletTable />}{" "}
        {/* Çalışanlar için tablo */}
      </div>
    </div>
  );
};

export default CompanyDetailTabs;
